<script setup>
import { ref, defineAsyncComponent } from 'vue'
import { Icon } from '@iconify/vue'
import { useRouter } from 'vue-router'
import { useChannelsStore } from '@/stores/channels'

import AlertPrice from '@/views/dash/channels/Pages/AlertPrice.vue'
import InputFormHorizontal from '@/components/UI/Form/InputFormHorizontal.vue'
import { executeLogin, initLogin, loadSDK } from '@/composables/useFacebookLogin'
import { notify } from '@kyvg/vue3-notification';
import Checkbox from 'primevue/checkbox';

const TabUserDepartment = defineAsyncComponent(() => import('@/components/tabs/TabUserDepartment.vue'))
const ChatTransition = defineAsyncComponent(() => import('@/components/utils/ChatTransition.vue'))
const Toggle = defineAsyncComponent(() => import('@/components/UI/Toogle/ToogleWithDescription.vue'))

const store = useChannelsStore()
const router = useRouter()

const authorizationAttendance = ref('')
const ignoreMessages = ref('')
const sipEnabled = ref(false)

store.channel.type = store.channel.type || 'whatsapp'
store.channel.server_type = store.channel.server_type || 'whatsapp_meta'

// Inicializar o objeto more se não existir
if (!store.channel.more) {
  store.channel.more = {}
}

if (store.channel?.start_service) {
  authorizationAttendance.value = 'true'
}

if (store.channel?.more?.sip_enabled !== undefined) {
  sipEnabled.value = store.channel.more.sip_enabled
}

if (store.channel?.more?.ignore_messages === undefined) {
  store.channel.more.ignore_messages = false
}
if (store.channel?.more?.ignore_messages) {
  ignoreMessages.value = 'true'
}

/**
 * WHATS META
 */
loadSDK(document, 'script', 'facebook-jssdk')

const appId = 1002416697451596
initLogin(appId)

let loginConfigs = ref({
  config_id: 3210690685734950, // configuration ID goes here
  response_type: 'code', // must be set to 'code' for System User access token
  override_default_response_type: true, // when true, any response types passed in the "response_type" will take precedence over the default types
  extras: {

    setup: {},
    featureType: "whatsapp_business_app_onboarding",
    sessionInfoVersion: "3"

    // version: 2, feature: 'whatsapp_embedded_signup', sessionInfoVersion: 2 

  }
})

const registerMetaUrl = `${window.origin}/v2/canais/cadastrar/whatsapp/whatsapp-meta`
const registerMetaParams = new URLSearchParams()

const loginMeta = response => {
  if (
    !response?.authResponse?.code ||
    !registerMetaParams.has('phone_number_id') ||
    !registerMetaParams.has('waba_id')
  ) {
    console.error(
      'Code',
      response?.authResponse?.code,
      'Register Params',
      registerMetaParams
    )
    notify({
      type: 'error',
      title: 'Opps...',
      text: 'Não foi possível realizar o login. Por favor, tente realizar o login no Facebook novamente!',
    })
    return
  }

  setTimeout(() => router.push({ name: 'channels.home' }), 1000)

  notify({
    type: 'success',
    title: 'Tudo certo...',
    text: 'Você será redirecionado para finalizar o cadastro do WhatsApp Meta!',
  })

  registerMetaParams.set('api_token', response.authResponse.code)


  const popup = window.open(
    `${registerMetaUrl}?${registerMetaParams.toString()}`,
    'integratedApiMeta',
    'toolbar=no, menubar=no, width=600, height=900, top=100, left=100'
  )

  if (!popup || popup.closed || typeof popup.closed == 'undefined') {
    notify({
      type: 'error',
      title: 'Atenção',
      text: 'O popup foi bloqueado pelo navegador. Por favor, permita popups para este site e tente novamente.'
    })
    return
  }

}

window.addEventListener('message', (event) => {
  if (
    event.origin !== "https://www.facebook.com" &&
    event.origin !== "https://web.facebook.com"
  ) {
    const data = JSON.parse(event.data);
    console.log('ORIGIN NÃO É FACEBOOK', event.origin, data)
    return;
  }

  try {
    const data = JSON.parse(event.data);
    console.log('DATA MESSAGE', data)
    if (data.type === 'WA_EMBEDDED_SIGNUP') {

      // if user finishes the Embedded Signup flow
      if (
        data.event === 'FINISH' ||
        data.event === 'FINISH_WHATSAPP_BUSINESS_APP_ONBOARDING'
      ) {
        const { phone_number_id, waba_id } = data.data;

        registerMetaParams.set('phone_number_id', phone_number_id)
        registerMetaParams.set('waba_id', waba_id)
        registerMetaParams.set('business_id', data.business_id)
      } else if (data.event === 'CANCEL') {
        // if user cancels the Embedded Signup flow
        const { current_step } = data.data;
        console.warn("Cancel at ", current_step);

        notify({
          type: 'error',
          title: 'Opps...',
          text: 'O processo foi cancelado pelo usuário!',
        })
      } else if (data.event === 'ERROR') {
        // if user reports an error during the Embedded Signup flow
        const { error_message } = data.data;
        console.error("error ", error_message);

        notify({
          type: 'error',
          title: 'Opps...',
          text: 'Não foi possível realizar o login: ' + error_message,
        })
      }
    }
  } catch {
    console.log('Non JSON Responses', event.data);
  }
});


function handleToggleAuthorization(value) {
  console.log(value)
  authorizationAttendance.value = value
  store.channel.start_service = null
}

function handleToggleSipEnabled(value) {
  if (!store.channel.more) {
    store.channel.more = {}
  }
  store.channel.more.sip_enabled = value
}

function handleToggleIgnoreMessages(value) {
  store.channel.more.ignore_messages = value === 'true'
}
</script>

<template>
  <template v-if="store.formStep === 2">
    <div class="space-y-4">
      <InputFormHorizontal v-if="store.channel?.id" v-model="store.channel.name" :init-value="store.channel.name"
        :block-edit="store.loading" label="Nome do canal" placeholder="Como você irá identificar o canal pelo sistema?"
        rules="required" vertical />

      <InputFormHorizontal v-if="store.channel?.id" :init-value="store.channel.user" :block-edit="true"
        label="Número do WhatsApp"
        hint="Ao cadastrar o canal, o número é vinculado automaticamente. Não é possível alterá-lo!" vertical />


      <Toggle v-model="authorizationAttendance" t-label="Autorização de inicio de atendimento"
        t-description="Ao habilitar essa função é possivel relacionar um usuario ou um departamento para iniciar um atendimento"
        @update:model-value="handleToggleAuthorization" />



      <Toggle v-model="ignoreMessages" t-label="Ignorar todas as mensagens?"
        @update:model-value="handleToggleIgnoreMessages"
        t-description="Ativando essa opção, o sistema irá ignorar todas as mensagens recebidas!" />

      <div v-if="store.channel?.more" class="flex items-center gap-2">
        <Checkbox v-model="sipEnabled" :binary="true" inputId="sip_enabled"
          @update:model-value="handleToggleSipEnabled" />
        <label for="sip_enabled" class="cursor-pointer">
          Habilitar SIP
        </label>
      </div>
      <ChatTransition :show="authorizationAttendance === 'true'" custom-class="form_group">
        <TabUserDepartment v-model="store.channel.start_service" />
      </ChatTransition>

      <button v-if="!store.channel?.id"
        class="flex justify-center items-center bg-green-500 hover:bg-green-600 text-white text-sm font-bold py-2 px-4 rounded-full chat_transition"
        :class="{ 'opacity-50 cursor-not-allowed': false }" @click.prevent.stop="executeLogin(loginMeta, loginConfigs)">
        <Icon icon="simple-icons:whatsapp" class="text-white h-4 w-4 mr-2" />
        Cadastrar/Vincular WhatsApp Oficial
      </button>

      <AlertPrice />
    </div>
  </template>

  <template v-else-if="store.formStep === 1">
    Instruções de cadastro
  </template>
</template>
